import { render, staticRenderFns } from "./SectionDividerEditor.vue?vue&type=template&id=4ef9ef74&scoped=true"
import script from "./SectionDividerEditor.vue?vue&type=script&lang=js"
export * from "./SectionDividerEditor.vue?vue&type=script&lang=js"
import style0 from "./SectionDividerEditor.vue?vue&type=style&index=0&id=4ef9ef74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef9ef74",
  null
  
)

export default component.exports